module.exports = "<div layout=\"row\" layout-align=\"center center\" ng-cloak>\n  <p flex=\"80\" ng-bind=\"$ctrl.pageMessage\"></p>\n</div>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/fileDownload/fileDownload.html
// module id = 2064
// module chunks = 0